import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Checkbox } from '@material-ui/core';
import DropdownMechanism from '../../../../../GeneralComponents/DropdownMechanism';

const defaultOptionTarget = 'none';

const AdvancedSelect = ({
  openAlert,
  editor,
  annotationName,
  customAttributeType,
  selectedProject,
  advanceSelectObject,
  setAdvanceSelectObject,
  lock,
  setLock,
  isAdvanceSelect,
  setIsAdvanceSelect,
  annotationTarget,
  setAnnotationTarget,
  setDisplayFlowData
}) => {
  const [annotations, setAnnotations] = useState([{}]);
  const [annotationTargets, setAnnotationTargets] = useState([]);
  

  useEffect(() => {
    if (selectedProject === '-1') return;
    setAnnotations(
      JSON.parse(localStorage.getItem('data'))[selectedProject].annotations[0].combinations
    );
  }, [selectedProject]);

  useEffect(() => {
    if (!Array.isArray(annotations)) return;
    setAnnotationTargets(
      annotations
        .filter(({ annotationLink }) => annotationLink === customAttributeType)
        .filter(({ annotationType }) => annotationType === 'attribute')
    );
  }, [annotations, customAttributeType]);


  useEffect(() => {
    setLock(isAdvanceSelect && annotationTarget === defaultOptionTarget);
  }, [annotationTarget, isAdvanceSelect]);

  useEffect( () => {

    if (openAlert === true && editor.getSelected() !== undefined) {
      const selected = editor.getSelected();

      if( selected.attributes.attributes['attached-subentity-attr'] !== undefined &&
          selected.attributes.attributes['attached-subentiy-attr'] !== 'none'
      ){
        setIsAdvanceSelect(true);
        setAdvanceSelectObject({optionAnnotationName: selected.attributes.attributes['attached-subentity-attr'],checked: true})
        setAnnotationTarget(selected.attributes.attributes['attached-subentity-attr'])
        setDisplayFlowData(true);
      }
      else{
        setAdvanceSelectObject({...advanceSelectObject,checked: false})
        setIsAdvanceSelect(false);
        setAnnotationTarget('none');
      }

    }
  },[openAlert])

  const handleHrefChecked = () => {
    setIsAdvanceSelect(!isAdvanceSelect);
    setAdvanceSelectObject({ ...advanceSelectObject, checked: !isAdvanceSelect });
  };

  const selectTarget = (option) => {
    setAnnotationTarget(option);
    if(option === 'none'){
      setIsAdvanceSelect(false);
      setAdvanceSelectObject({...advanceSelectObject,optionAnnotationName: option, checked: false})
    }
    else{
      setAdvanceSelectObject({...advanceSelectObject,optionAnnotationName: option, checked: true})
      setIsAdvanceSelect(true)
    }
  };

  const blueFontColor = { color: '#0c4d82' };
  const redFontColor = { color: 'red' };
  return (
    <div className={clsx('spacingTopDiv')}>
      <Checkbox
        checked={isAdvanceSelect}
        style={blueFontColor}
        onChange={handleHrefChecked}
        inputProps={{ 'aria-label': 'uncontrolled-checkbox' }}
      />
      &nbsp; Attach to entity: &nbsp;{' '}
      <div>
        <span style={{ display: 'inline-block', marginLeft: '1vw' }}>&nbsp;</span>
        <div style={{ display: 'inline-flex', paddingTop: '0.5vw' }}>
          <span>Select an item from</span>
          <span style={blueFontColor}>&nbsp;{customAttributeType}&nbsp;</span>
          <span> using the attribute &nbsp;</span>
          <span style={lock ? redFontColor : blueFontColor}>
            {' '}
            <DropdownMechanism
              target={annotationTarget}
              targets={['none',...annotationTargets.map((annotation) => annotation.annotationName)]}
              selectTarget={selectTarget}
            />
          </span>
          
        </div>
        <span> and set it as</span>
        <span style={blueFontColor}> {annotationName}</span>
      </div>
      <span
            className={clsx('MuiFormHelperText-root', 'Mui-error')}
            style={
              lock === true
                ? { display: 'inherit',  marginLeft: '1.2vw' }
                : { display: 'none' }
            }
          >
          None attribute
        </span>
    </div>
  );
};

export default AdvancedSelect;
